export default "__VITE_ASSET__C_Z3JGSA__"